export default __webpack_public_path__ + "static/media/4.2db7e59d.jpg";